import {useAppSelector} from '../../../helpers/reduxHelpers';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../services/tracking';
import {getAnalyticsTrackingData, serializeSavedViewId} from './analyticsSelectors';

export function useAnalyticsTracking() {
  const trackingData = useAppSelector(getAnalyticsTrackingData);

  return (type: InterfaceEventsEnum, eventData?: {[key: string]: any}) => {
    const {saved_view_id: savedViewId, ...otherEventData} = eventData ?? {};
    trackInterfaceEvent(type, {
      ...trackingData,
      // If the user provided another saved_view_id, we serialize it & override the existing one.
      ...(savedViewId ? serializeSavedViewId(savedViewId) : {}),
      ...otherEventData,
    });
  };
}
